"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    1: {
      stepLabel: 'Step %{stepNumber}',
      stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}'
    },
    2: {
      stepLabel: 'Step %{stepNumber}',
      stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}'
    },
    3: {
      stepLabel: 'Step %{stepNumber}',
      stepTrackerLabel: 'Step %{stepNumber} of %{stepCount}: %{stepLabel}'
    }
  },
  fr: {
    1: {
      stepLabel: 'Étape %{stepNumber}',
      stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}'
    },
    2: {
      stepLabel: 'Étape %{stepNumber}',
      stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}'
    },
    3: {
      stepLabel: 'Étape %{stepNumber}',
      stepTrackerLabel: 'Étape %{stepNumber} sur %{stepCount}: %{stepLabel}'
    }
  }
};